import cn from 'classnames'
import { observer } from 'mobx-react'
import React, { useMemo } from 'react'

import { useRecordWisePipelinesStore } from '@flowwai-frontend/bps-officer-web/common/data-access'
import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'
import {
   useAutoScrolling,
   useCustomT
} from '@flowwai-frontend/shared/common-components'
import { usePipelineStore } from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

import PipelinePopoverItem from './PipelinePopoverItem'
import * as Styles from './styles'

interface Props {
   pipelineItemId: string
   onSelect: (pipelineId: string) => void
}

const PipelinesSelectionPopoverBody = (props: Props): React.ReactElement => {
   const { pipelineItemId, onSelect } = props

   const recordWisePipelinesStore = useRecordWisePipelinesStore()
   const t = useCustomT('common:recordPipelineSelection')
   const autoScrolling = useAutoScrolling()

   const { theme } = useAppTheme()
   const pipelinesPopoverTheme = theme.common.pipelinesPopover

   const pipelineStore = usePipelineStore()

   const pipelineModels = useMemo(() => {
      const pipelineIds = recordWisePipelinesStore.getRecordPipelineIds(
         pipelineItemId
      )

      return pipelineIds.map(pipelineStore.getPipeline)
   }, [])

   const isPipelinesExists = pipelineModels.length > 0

   const renderNoDataView = (): React.ReactElement => (
      <div
         className={cn(
            Styles.noDataViewStyles,
            pipelinesPopoverTheme.noDataViewText
         )}
      >
         {t('noPipelinesFound')}
      </div>
   )

   const renderHeader = () => (
      <div
         className={cn(
            Styles.headerContainerStyles,
            pipelinesPopoverTheme.headerBorderColor
         )}
      >
         <span
            className={cn(
               Styles.headerTextStyles,
               pipelinesPopoverTheme.headerTextColor
            )}
         >
            {t('header.title')}
         </span>
      </div>
   )

   const renderPipelines = (): React.ReactElement => (
      <div
         className={cn(
            Styles.pipelinesListContainerStyles,
            autoScrolling.className
         )}
         ref={autoScrolling.ref}
      >
         {pipelineModels.map(eachPipeline => (
            <PipelinePopoverItem
               key={eachPipeline.pipelineId}
               pipelineModel={eachPipeline}
               onSelect={onSelect}
            />
         ))}
      </div>
   )

   return (
      <div className='w-full h-full'>
         {renderHeader()}
         {isPipelinesExists ? renderPipelines() : renderNoDataView()}
      </div>
   )
}

export default observer(PipelinesSelectionPopoverBody)
